import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

/**
 * Blocks in-app navigation (useBlocker) and tab/browser close (beforeunload)
 * while a verification process is in progress.
 */
export function useVerificationBlocker(isBlocking: boolean) {
  const blocker = useBlocker(isBlocking);

  // beforeunload safety net for tab close / refresh
  useEffect(() => {
    if (!isBlocking) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isBlocking]);

  return { blocker };
}
